// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal_modal__2shZo","header":"modal_header__2v0BA","meta":"modal_meta__3-XeV","content":"modal_content__1vAfz","wrapper":"modal_wrapper__SsUFx"};